var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "image-icons"
  }, [_c('div', [_c('b-icon', {
    staticClass: "action-icon",
    attrs: {
      "icon": "heart"
    }
  })], 1), _c('div', [_c('b-icon', {
    staticClass: "action-icon",
    attrs: {
      "icon": "share"
    }
  })], 1)]), _c('b-carousel', {
    staticStyle: {
      "text-shadow": "0px 0px 2px #000"
    },
    attrs: {
      "id": "carousel-fade",
      "fade": "",
      "indicators": "",
      "img-width": "1024",
      "img-height": "480"
    }
  }, [_c('b-carousel-slide', {
    attrs: {
      "caption": "",
      "img-src": "https://picsum.photos/1024/480/?image=10"
    }
  }), _c('b-carousel-slide', {
    attrs: {
      "caption": "",
      "img-src": "https://picsum.photos/1024/480/?image=12"
    }
  }), _c('b-carousel-slide', {
    attrs: {
      "caption": "",
      "img-src": "https://picsum.photos/1024/480/?image=22"
    }
  })], 1)], 1), _c('div', [_c('h3', {
    staticClass: "mt-3 heading"
  }, [_vm._v("Rate & Reviews")]), _c('div', [[_c('div', [_c('b-form-rating', {
    staticClass: "review-star",
    attrs: {
      "readonly": "",
      "variant": "warning",
      "inline": "",
      "no-border": ""
    },
    model: {
      value: _vm.starValue,
      callback: function ($$v) {
        _vm.starValue = $$v;
      },
      expression: "starValue"
    }
  })], 1)], _c('div', [_c('p', {
    staticClass: "review-title"
  }, [_vm._v("Good Service")]), _c('p', [_vm._v(" Lorem ipsum dolor sit amet consectetur, adipisicing elit. Deleniti, asperiores. ")]), _c('p', {
    staticClass: "reviewer"
  }, [_vm._v("John George")])]), _c('hr')], 2)])]), _c('b-col', {
    attrs: {
      "offset": "2",
      "md": "5"
    }
  }, [_c('div', [_c('h3', {
    staticClass: "mt-2 heading"
  }, [_vm._v("Hospital Name")]), _c('b-row', [_c('b-col', [_c('p', {
    staticClass: "hospital-text reviewer mb-0"
  }, [_vm._v("St. Michael Church Road, Mumbai , Maharashtra")])])], 1)], 1), _c('div', {
    staticClass: "hospital-text mt-2 mb-3"
  }, [_c('b', [_vm._v("Contact:")]), _c('span', [_vm._v("+91 987654321")])]), _c('div', {
    staticClass: "hospital-text mt-0"
  }, [_c('b-row', [_c('b-col', [_c('b', {
    staticClass: "mb-0 hospital-text"
  }, [_vm._v("Open Time: 7:00 AM - Close Time: 10:00 PM")])])], 1)], 1), _c('div', {
    staticClass: "mt-3"
  }, [_c('b', {
    staticClass: "hospital-text"
  }, [_vm._v("About Hospital")]), _c('p', [_vm._v(" Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iste reiciendis quasi minima, et dolorum nostrum explicabo nam perferendis voluptates labore aliquam accusantium pariatur sit incidunt quas sequi est nihil doloremque! ")])]), _c('div', {
    staticClass: "mt-3",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v("Major Specialities")]), _c('ul', {
    staticClass: "mt-2"
  }, [_c('li', [_vm._v(" Cardiac Surgery - Adult. ...")]), _c('li', [_vm._v(" Cardiology - Adult. ...")]), _c('li', [_vm._v(" Microbiology. ...")]), _c('li', [_vm._v(" Radiology. ...")]), _c('li', [_vm._v(" General Surgery. ...")]), _c('li', [_vm._v(" Gastroenterology - Medical. ...")]), _c('li', [_vm._v(" Electrophysiology. ...")]), _c('li', [_vm._v(" Gastroenterology - Surgical")])])]), _c('div', {
    staticClass: "text-center mt-5"
  }, [_c('b-button', {
    staticClass: "custom-button",
    attrs: {
      "block": "",
      "variant": "custom"
    }
  }, [_vm._v("Proceed")])], 1)])], 1), _c('b-row', [_c('b-col', [_c('b-container', [_vm.$options.components['advertisement-bottom-banner'] ? [_c('advertisement-bottom-banner')] : _vm._e()], 2)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }